import { render } from "./Order.vue?vue&type=template&id=568e89f7&scoped=true"
const script = {}

import "./Order.vue?vue&type=style&index=0&id=568e89f7&scoped=true&lang=css"

import exportComponent from "/vercel/path0/my_res/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-568e89f7"]])

export default __exports__